import React, { useState, useEffect } from "react";
import Select from "react-select";
import { createEnquiry, getAllServices } from "../../../redux/actions/authActions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { message } from "antd";

function AddEnquiresHome() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const services = useSelector((state) => state.auth.allServices);

  // 1. Keys now match Backend Schema exactly
  const [formData, setFormData] = useState({
    companyName: "",
    clientName: "",
    emailAddress: "",
    clientType: "Private Limited",
    phoneNumber: "",
    services: [], // Changed from 'opted'
  });

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) dispatch(getAllServices(token));
  }, [dispatch]);

  const handleChange = (e) => {
    const { id, value } = e.target;
    if (id === "phoneNumber") {
      const numericValue = value.replace(/\D/g, "");
      if (numericValue.length <= 10) {
        setFormData({ ...formData, [id]: numericValue });
      }
    } else if (id === "clientName") { // Updated ID check
      const lettersOnly = value.replace(/[^a-zA-Z\s]/g, "");
      if (lettersOnly.length <= 40) {
        setFormData({ ...formData, [id]: lettersOnly });
      }
    } else {
      setFormData({ ...formData, [id]: value });
    }
  };

  const handleSelectChange = (selectedOptions) => {
    setFormData({
      ...formData,
      services: selectedOptions
        ? selectedOptions.map((option) => option.value)
        : [],
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation
    if (!formData.clientType) return message.error("Please select client type");
    if (formData.phoneNumber.length < 10) return message.error("Invalid Phone Number");
    if (formData.services.length === 0) return message.error("Please select at least one service");

    try {
      // 2. Pass formData directly - no manual mapping needed anymore
      await dispatch(createEnquiry(formData));
      message.success("Enquiry added successfully");
      navigate("/enquires");
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      // If backend sends a specific error message, it will show here
      message.error(error.response?.data?.message || "Failed to add enquiry");
    }
  };

  const handleCancel = () => navigate("/enquires");

  const serviceOptions = services?.map((service) => ({
    value: service._id,
    label: service.name,
  }));

  const selectStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: "#f9fafb",
      borderColor: state.isFocused ? "#3b82f6" : "#d1d5db",
      borderRadius: "8px",
      fontSize: "14px",
    }),
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-gray-800 mb-6">Add Enquiry</h1>
      <div className="bg-white rounded-xl shadow-lg p-8">
        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-4">
              <div>
                <label htmlFor="companyName" className="block mb-2 text-xs font-semibold text-gray-500 uppercase">Company Name</label>
                <input
                  type="text"
                  id="companyName" // Matches Schema
                  value={formData.companyName}
                  onChange={handleChange}
                  className="bg-gray-50 border border-gray-300 text-sm rounded-lg block w-full p-2.5"
                  required
                />
              </div>
              <div>
                <label htmlFor="clientName" className="block mb-2 text-xs font-semibold text-gray-500 uppercase">Contact Person Name</label>
                <input
                  type="text"
                  id="clientName" // Matches Schema
                  value={formData.clientName}
                  onChange={handleChange}
                  className="bg-gray-50 border border-gray-300 text-sm rounded-lg block w-full p-2.5"
                  required
                />
              </div>
              <div>
                <label htmlFor="emailAddress" className="block mb-2 text-xs font-semibold text-gray-500 uppercase">Email Address</label>
                <input
                  type="email"
                  id="emailAddress" // Matches Schema
                  value={formData.emailAddress}
                  onChange={handleChange}
                  className="bg-gray-50 border border-gray-300 text-sm rounded-lg block w-full p-2.5"
                  required
                />
              </div>
              <div>
                <label htmlFor="clientType" className="block mb-2 text-xs font-semibold text-gray-500 uppercase">Client Type</label>
                <select
                  id="clientType"
                  value={formData.clientType}
                  onChange={handleChange}
                  className="bg-gray-50 border border-gray-300 text-sm rounded-lg block w-full p-2.5"
                  required
                >
                  <option value="Private Limited">Private Limited</option>
                  <option value="Partnership">Partnership</option>
                  <option value="Proprietorship">Proprietorship</option>
                </select>
              </div>
              <div>
                <label htmlFor="phoneNumber" className="block mb-2 text-xs font-semibold text-gray-500 uppercase">Phone Number</label>
                <input
                  type="text"
                  id="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  className="bg-gray-50 border border-gray-300 text-sm rounded-lg block w-full p-2.5"
                  required
                />
              </div>
            </div>

            <div className="space-y-4">
              <div>
                <label htmlFor="services" className="block mb-2 text-xs font-semibold text-gray-500 uppercase">Services Enquired For</label>
                <Select
                  id="services"
                  options={serviceOptions}
                  isMulti
                  onChange={handleSelectChange}
                  styles={selectStyles}
                  placeholder="Select services"
                />
              </div>
            </div>
          </div>

          <div className="mt-8 flex justify-end space-x-4">
            <button type="button" onClick={handleCancel} className="px-6 py-2 border border-gray-300 rounded-full text-sm">Cancel</button>
            <button type="submit" className="px-6 py-2 bg-blue-600 text-white rounded-full text-sm">Create Enquiry</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddEnquiresHome;